import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertCircle, CheckCircle2 } from 'lucide-react';

interface PainSolutionBlockProps {
  problemTitle: string;
  problemBullets: string[];
  solutionTitle: string;
  solutionBullets: string[];
}

export const PainSolutionBlock = ({
  problemTitle,
  problemBullets,
  solutionTitle,
  solutionBullets
}: PainSolutionBlockProps) => {
  return (
    <div className="grid md:grid-cols-2 gap-8">
      {/* Problem */}
      <Card className="border-destructive/50">
        <CardHeader>
          <div className="flex items-center gap-3 mb-2">
            <AlertCircle className="w-6 h-6 text-destructive" />
            <CardTitle className="text-destructive">{problemTitle}</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <ul className="space-y-3">
            {problemBullets.map((bullet, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-muted-foreground">
                <span className="text-destructive mt-0.5">•</span>
                <span>{bullet}</span>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>

      {/* Solution */}
      <Card className="border-primary">
        <CardHeader>
          <div className="flex items-center gap-3 mb-2">
            <CheckCircle2 className="w-6 h-6 text-primary" />
            <CardTitle className="text-primary">{solutionTitle}</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <ul className="space-y-3">
            {solutionBullets.map((bullet, index) => (
              <li key={index} className="flex items-start gap-2 text-sm">
                <CheckCircle2 className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
                <span>{bullet}</span>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
};
